import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { decryptId } from "../../services/apiService";
import { generatePDFFromHTML } from "../../Uitiles/GeneratePDFFromHTML";

const InvoiceDownload = () => {
  const { invoiceId } = useParams();
  const decodedId = decryptId(invoiceId);
  const [response, setResponse] = useState(null);

  useEffect(() => {
    const generatePDF = async () => {
      try {
        const result = await generatePDFFromHTML({ id: decodedId });

        if (result) {
          const res = {
            status: "success",
            message: "Invoice downloaded successfully",
            invoice_id: decodedId,
          };
          setResponse(res);

          // If opened directly in browser, show JSON
          console.log("API Response:", res);

          // ✅ Optionally trigger JSON file download:
          // const blob = new Blob([JSON.stringify(res, null, 2)], { type: "application/json" });
          // const link = document.createElement("a");
          // link.href = URL.createObjectURL(blob);
          // link.download = `invoice-${decodedId}.json`;
          // link.click();
        } else {
          setResponse({
            status: "error",
            message: "Failed to generate invoice PDF",
          });
        }
      } catch (err) {
        setResponse({
          status: "error",
          message: err.message || "Unexpected error occurred",
        });
      }
    };

    if (decodedId) generatePDF();
  }, [decodedId]);

  // ✅ Return pure JSON-like view (no HTML layout)
  if (!response) {
    return (
      <pre style={{ fontFamily: "monospace" }}>
        {JSON.stringify({ status: "loading", message: "Preparing invoice..." }, null, 2)}
      </pre>
    );
  }

  return <pre style={{ fontFamily: "monospace" }}>{JSON.stringify(response, null, 2)}</pre>;
};

export default InvoiceDownload;
